import { render, staticRenderFns } from "./porposal-edit.vue?vue&type=template&id=d2695ee2&scoped=true&"
import script from "./porposal-edit.vue?vue&type=script&lang=ts&"
export * from "./porposal-edit.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-edit.vue?vue&type=style&index=0&id=d2695ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2695ee2",
  null
  
)

export default component.exports